import * as SampleStatisticsConstants from './SampleStatisticsConstants';
import { produce } from "immer";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState ={
    isSampleStatsDataFetched: false,
    isSampleStatsDataFetching: false,
    isSampleStatsDataFetchingFailed: false,
    sampleStatsData: [],
};

export default function SampleStatsReducer(state = {}, action) {

    switch (action.type) {

        case  SampleStatisticsConstants.SAMPLE_STAT_DATA_STATE_ADD: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    
                }
            });
            return assign({}, state, newState);
        }

        case SampleStatisticsConstants.SAMPLE_STAT_DATA_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }

        
        case SampleStatisticsConstants.SAMPLE_STATISTICS_DATA_FETCHING:{
            
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isSampleStatsDataFetched: false,
                    isSampleStatsDataFetching: true,
                    isSampleStatsDataFetchingFailed: false,
                    sampleStatsData: []
                };
            });
            
            return assign({}, state,newState);
        }  
        

        case SampleStatisticsConstants.SAMPLE_STATISTICS_DATA_FETCHED:{
           
            console.log("Sample stats data",action);
            const newState = produce(state, (draft) => {
                
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isSampleStatsDataFetched: true,
                    isSampleStatsDataFetching: false,
                    isSampleStatsDataFetchingFailed: false,
                    sampleStatsData: action.payload.newState.result
                }
                
            });
            return assign({}, state,newState);
        }
        
        case SampleStatisticsConstants.SAMPLE_STATISTICS_DATA_FETCHING_FAILED:{
            
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isSampleStatsDataFetched: true,
                    isSampleStatsDataFetching: false,
                    isSampleStatsDataFetchingFailed: false,
                    sampleStatsData: []
                    
                }
            });

            return assign({}, state,newState);
        }


        break;   
        
        default:
        return state;

    }

}